
import { supabaseWorker } from '@/integrations/supabase/workerClient';
import { SearchResult } from './types';
import { calculateRelevance, detectQueryType } from './utils';

export const searchTasks = async (query: string, limit: number): Promise<SearchResult[]> => {
  const queryType = detectQueryType(query);

  type Thenable<T> = { then: (onfulfilled: (value: T) => void, onrejected: (reason: unknown) => void) => unknown };
  const wrapThenable = <T>(qb: Thenable<T>): Promise<T> => new Promise((resolve, reject) => qb.then(resolve, reject));

  const baseSelect = () =>
    supabaseWorker
      .from('tasks')
      .select('id, title, description, status, created_at');

  type DbTaskRow = {
    id: string;
    title: string | null;
    description: string | null;
    status: string | null;
    created_at: string;
  };
  let promises: Array<Promise<{ data: DbTaskRow[] | null; error: unknown | null }>> = [];

  if (queryType === 'id') {
    promises = [
      wrapThenable(baseSelect().eq('id', query).limit(limit)),
      wrapThenable(baseSelect().ilike('id', `${query}%`).limit(limit)),
      wrapThenable(baseSelect().ilike('title', `%${query}%`).limit(limit)),
    ];
  } else {
    promises = [
      wrapThenable(baseSelect().ilike('title', `%${query}%`).limit(limit)),
      wrapThenable(baseSelect().ilike('description', `%${query}%`).limit(limit)),
    ];
  }

  const results = await Promise.all(promises);
  const hasData = results.some(r => Array.isArray(r?.data) && (r.data as unknown[]).length > 0);
  const hadError = results.some(r => r && r.error);
  if (hadError && !hasData) {
    const firstErr = results.find(r => r && r.error)?.error as unknown;
    // eslint-disable-next-line no-console
    console.error('[GlobalSearch][tasks] source error:', firstErr);
    // не бросаем; позволяем searchService агрегировать частичные результаты
  }
  const rows = results.flatMap(r => (Array.isArray(r?.data) ? r.data! : []));
  const unique = Array.from(new Map(rows.map(r => [r.id, r])).values()).slice(0, limit);

  return unique.map(dbTask => ({
    id: dbTask.id,
    type: 'task' as const,
    title: dbTask.title || 'Без названия',
    subtitle: 'Задача',
    description: dbTask.description || '',
    icon: 'CheckSquare',
    url: `/tasks`,
    relevance: calculateRelevance(query, [dbTask.title, dbTask.description || ''], queryType),
    createdAt: dbTask.created_at,
    status: dbTask.status
  }));
};
